import { collections } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function Collections() {
  return (
    <section id="collections" className="w-full bg-background-100 px-4 py-10 md:px-6 md:py-14">
      <div className="mx-auto max-w-[1280px]">
        <SectionHeading
          eyebrow="Collections"
          title="编辑精选专题合集"
          desc="比起一部一部翻，合集按阅读场景打包整理。想熬夜一次看完、想收藏高水平画风、想动脑推理，各进一个。"
          actionText="全部专题合集"
        />

        <div className="grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-6">
          {collections.map((collection) => (
            <a
              key={collection.id}
              href="#top"
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:border-accent-300"
            >
              <div className="relative h-48 w-full overflow-hidden md:h-52">
                <img
                  src={collection.image}
                  alt={`${collection.title} 韩国漫画专题合集`}
                  title={`${collection.title} 韩国漫画推荐合集`}
                  className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 to-transparent" />
                <span className="absolute left-4 top-4 rounded-full bg-accent-500 px-3 py-1 text-[11px] font-bold text-foreground-950">
                  {collection.tag}
                </span>
                <span className="absolute bottom-4 left-4 text-xs font-medium text-background-100">
                  {collection.count}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-lg font-bold text-foreground-950">{collection.title}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{collection.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-primary-600 transition-transform group-hover:translate-x-0.5">
                  进入合集
                  <i className="ri-arrow-right-line text-base" />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}